import { useSetAtom } from "jotai";
import { useClientsState } from "atoms/clientsAtom";
import {
  setAccureBonusesModalAtom,
  setChangeClientGroupModalAtom,
  setClientModalAtom,
  setConfirmationModalAtom,
  setInfoModalAtom,
  setModalCloseAtom,
} from "atoms/modalAtom/modalAtom";

import { Button } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

import { useDeleteClient } from "../api";

export const ClientsFooter = (): JSX.Element => {
  const { clientsState } = useClientsState();
  const setClientModal = useSetAtom(setClientModalAtom);
  const closeModal = useSetAtom(setModalCloseAtom);
  const setConfirmModal = useSetAtom(setConfirmationModalAtom);
  const setChangeClientGroupModal = useSetAtom(setChangeClientGroupModalAtom);
  const setAccureBonusesModal = useSetAtom(setAccureBonusesModalAtom);
  const setInfoModal = useSetAtom(setInfoModalAtom);

  const { mutateAsync: deleteClientAsync } = useDeleteClient();

  const onConfirm = async () => {
    if (clientsState.activeItems.length) {
      const promises: Promise<any>[] = [];

      clientsState.activeItems.forEach((item) => {
        promises.push(deleteClientAsync(item.clientid));
      });

      await Promise.all(promises);
    }

    closeModal();
  };

  const handleDeleteClick = () => {
    if (clientsState.activeItems.length) {
      setConfirmModal({
        title: `Вы действительно хотите удалить выбранных клиентов (${clientsState.activeItems.length})?`,
        onConfirm,
      });
    } else {
      alert("Вам нужно выбрать клиента, чтобы иметь возможность удалить его.");
    }
  };

  const handleChangeGroupClick = () => {
    if (clientsState.activeItems.length) {
      setChangeClientGroupModal();
    } else {
      setInfoModal({
        title:
          "Вам нужно выбрать клиента, чтобы иметь возможность перенести его в другую группу.",
        height: 250,
      });
    }
  };

  const handleAddClick = () => {
    if (clientsState.activeGroupItem) {
      setClientModal();
    }
  };

  /*const handleInfoClick = () => {
    if (clientsState.activeItems.length === 1) {
      setClientModal(true);
    } else {
      setInfoModal({
        title:
          "Вам нужно выбрать одного клиента, чтобы иметь возможность просмотреть его информацию.",
        height: 250,
      });
    }
  };*/

  return (
    <div className="flex flex-row ">
      <Button
        onClick={handleAddClick}
        icon="plus"
        disabled={!clientsState.activeGroupItem}
      />
      <HorizontalSpace size={11} />
      <Button
        icon="delete"
        onClick={handleDeleteClick}
        disabled={!clientsState.activeItems.length}
      />
      {/*<HorizontalSpace size={11} />
      <Button
        onClick={handleInfoClick}
        icon="info"
        disabled={!clientsState.activeItems.length}
      />*/}
      {/*<HorizontalSpace size={11} />
      <Button icon="sms" />
      <HorizontalSpace size={11} />
      <Button icon="printer" />*/}
      <HorizontalSpace size={11} />
      <Button
        icon="move"
        onClick={handleChangeGroupClick}
        disabled={!clientsState.activeItems.length}
      />
      <HorizontalSpace size={11} />
      <Button
        icon="coins"
        onClick={setAccureBonusesModal}
        disabled={!clientsState.activeItems.length}
      >
        Начислить бонусы массово
      </Button>
    </div>
  );
};
